import React, { Fragment, useState, useRef, useEffect } from 'react'
import { Box, Fade, Typography, IconButton, TextField } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { donateAmount } from 'actions/event'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { openLoginDialog } from 'actions/login-dialog'
import { openSnackBar } from 'actions/snack-bar'
import lottieJson from 'assets/small-lottie.json'
import bigLottie from 'assets/big-lottie.json'
import { Formik, Form } from 'formik'
import LoaderButton from 'components/LoaderButton'
import * as Yup from 'yup'
import HelpText from '../HelpText'
import { formatMoney } from 'accounting'
import CheckIcon from '@material-ui/icons/Check'
import QuantityInput from 'components/QuantityInput'
import useMaxAvailable from 'hooks/useMaxAvailable'
import useBidAmount from 'hooks/useBidAmount'
import { purchaseFixed } from 'actions/items'
import Button from '../Button'
import classnames from 'clsx'
import Gradient from 'components/Gradient'
//import ClosedCaptions from 'components/ClosedCaptions'
import { useMemo } from 'react'
import ClosedCaptions from 'components/ClosedCaptions'

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const vibrateArr = [
  100,
  50,
  20,
  20,
  20,
  20,
  20,
  300,
  100,
  50,
  20,
  20,
  20,
  20,
  20,
  300,
  100,
  50,
  20,
  20,
  20,
  20,
  20
]

let showThanksTimeout = null

const FixedButton = ({ classes }) => {
  const dispatch = useDispatch()
  const orientation = useSelector(state => state.window.orientation)
  const [showThanks, setShowThanks] = useState(false)
  const [showCustom, setShowCustom] = useState(false)
  const [showDonateSuccess, setShowDonateSuccess] = useState(false)
  const [customAmount, setCustomAmount] = useState('')
  const [selectedDonateAmount, setSelectedDonateAmount] = useState(0)
  const [showConfirm, setShowConfirm] = useState(false)
  const items = useSelector(state => state.items.items)
  const item = items.find(i => i.is_live)
  const event = useSelector(state => state.event.event)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const eventBidApproval = useSelector(
    state => state.event.event.require_approval
  )
  const [actionType, setActionType] = useState('')

  const [showApprove, setShowApprove] = useState(true)

  const authentication = useSelector(
    state => state.authentication.authenticatedUser
  )
  const chats = useSelector(state => state.event.chats)
  //variable to hold for approved users
  let userBidSetting = '0'

  //find what action should be displayed
  useMemo(() => {
    if (item.open_item && event.auction_format === 10) {
      setActionType('Vote')
    } else if (item.open_item && event.auction_format !== 10) {
      setActionType('Donate')
    } else if (!item.open_item && event.auction_format !== 10) {
      setActionType('Buy')
    } else if (!item.open_item && event.auction_format === 10) {
      setActionType('Vote')
    }
  }, [item, item.open_item, event, event.auction_format])

  useEffect(() => {
    //get the event based on event id / auction code
    try {
      const userBidSettingArray = authenticatedUser.user_events.filter(
        x => x.eid.toString() === event.auction_code.toString()
      )
      userBidSetting = userBidSettingArray[0].approved.toString()
      setShowApprove(
        eventBidApproval.toString() === '0' ||
          (userBidSetting.toString() === '1' &&
            eventBidApproval.toString() === '1')
      )
    } catch (err) {
      userBidSetting = '0'
      console.error(err)
    }
    //set that setting to var
  }, [authenticatedUser, authentication, event, userBidSetting])
  // refs
  const customFixedRef = useRef(null)

  const maxQuantity = useMaxAvailable(item)
  const bidAmount = useBidAmount(item)

  let donateOptions = []
  if (event && event.giving_levels) {
    try {
      donateOptions = JSON.parse(event.giving_levels)
    } catch (err) {
      console.log(err)
    }
  }

  const checkLogin = (cb, ...args) => {
    console.log(cb, 'cb?')
    console.log(args, 'args?')
    if (isEmpty(authenticatedUser)) {
      dispatch(openLoginDialog())
        .then(response => {
          cb(...args, response)
        })
        .fail(() => {
          args[1].setSubmitting(false)
        })
    } else {
      cb(...args)
    }
  }

  const handleSubmit = (values, actions, loginResponse) => {
    let data = {
      user_id: loginResponse
        ? loginResponse.user_id
        : authenticatedUser.user_id,
      currency: 'usd',
      items: [],
      pay_type: 'cash',
      paid: 0,
      anon: values.anonFlag
    }
    if (item.open_item) {
      data.items.push({
        item_id: item.item_id,
        amount: values.customAmount
      })
    } else {
      for (let i = 0; i < values.quantity; i++) {
        data.items.push({
          item_id: item.item_id,
          amount: bidAmount
        })
      }
    }
    dispatch(purchaseFixed(data))
      .then(res => {
        const lottiePlayer = document.getElementById('purchase-lottie')
        if (lottiePlayer) {
          lottiePlayer.style.display = 'block'
          const lottieCompleteListener = () => {
            lottiePlayer.style.display = 'none'
            lottiePlayer.seek(0)
            lottiePlayer.removeEventListener('complete', lottieCompleteListener)
          }
          lottiePlayer.addEventListener('complete', lottieCompleteListener)
          lottiePlayer.play()
        }
        setShowConfirm(false)
        setShowDonateSuccess(true)
        setShowThanks(true)
        showThanksTimeout = setTimeout(() => {
          setShowThanks(false)
        }, 8000)
        if (navigator.vibrate) {
          navigator.vibrate(vibrateArr)
          setTimeout(() => {
            navigator.vibrate(vibrateArr)
          }, 3000)
          setTimeout(() => {
            navigator.vibrate(vibrateArr)
          }, 6000)
        }
        setTimeout(() => {
          actions.resetForm()
          setShowCustom(false)
        }, 300)
      })
      .catch(err => {
        console.error(err)
        dispatch(
          openSnackBar({
            message: 'There was an error purchasing this item'
          })
        )
      })
      .finally(() => {
        actions.setSubmitting(false)
      })
  }

  const AmountSchema = Yup.object().shape({
    customAmount: Yup.number()
      .required('Custom amount required')
      .min(1, 'Custom amount should be greater than 0')
  })

  const QuantitySchema = Yup.object().shape({
    quantity: Yup.number()
      .required('Quantity required')
      .min(1, 'Quantity should be greater than 1')
      .max(maxQuantity, `Quantity should be less than ${maxQuantity + 1}`)
  })

  const handleButtonClick = amount => {
    setSelectedDonateAmount(amount)
    setTimeout(() => {
      setShowConfirm(true)
    }, 40)
  }

  const handleCloseConfirm = resetForm => {
    setShowConfirm(false)
    setTimeout(() => {
      setShowCustom(false)
      resetForm()
    }, 300)
  }

  const handlePurchaseButtonClick = () => {
    if (item.open_item) {
      setShowCustom(true)
      setTimeout(() => {
        if (customFixedRef.current) {
          customFixedRef.current.focus()
        }
      }, 300)
    }
    setTimeout(() => {
      setShowConfirm(true)
    }, 40)
  }

  const handleCloseThanks = () => {
    setShowThanks(false)
    clearTimeout(showThanksTimeout)
    showThanksTimeout = null
  }
  //conditional rendering
  const captionShow = useSelector(state => state.stream.captions)
  //stuff needed for getting the url/stream_id
  const videoControlled = useSelector(
    state =>
      state.stream.cloudinaryVideoControlled &&
      state.stream.egLiveVideoControlled
  )

  const hasLiveVideo =
    event.live_url_data && event.live_url_data.find(x => x.live_now)

  const liveVideo =
    // videoControlled here is for weird mobile issue
    videoControlled && hasLiveVideo

  const idCheck = () => {
    if (liveVideo !== undefined) {
      return liveVideo.id
    } else {
      return 0
    }
  }

  return (
    <Box className={classnames(classes.fixedButton, classes[orientation])}>
      <Fade in={showThanks}>
        <Box className={classes.blueBox}>
          <IconButton
            size="small"
            className={classes.closeConfirmButton}
            onClick={handleCloseThanks}
          >
            <CloseIcon />
          </IconButton>
          <Typography className={classes.confirmText}>
            <CheckIcon /> Successfully added to your cart
          </Typography>
        </Box>
      </Fade>
      <Fade in={showConfirm}>
        <Box className={classes.blueBox}>
          {showCustom && (
            <Formik
              initialValues={{ customAmount: '' }}
              validationSchema={AmountSchema}
              onSubmit={(...args) => checkLogin(handleSubmit, ...args)}
            >
              {props => (
                <Form className={classes.form}>
                  <IconButton
                    size="small"
                    className={classes.closeConfirmButton}
                    onClick={() => handleCloseConfirm(props.resetForm)}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Fragment>
                    <Typography className={classes.confirmText}>
                      Enter custom amount
                    </Typography>
                    <TextField
                      className={classes.textField}
                      name="customAmount"
                      value={props.values.customAmount}
                      onChange={props.handleChange}
                      type="number"
                      error={Boolean(props.errors.customAmount)}
                      helperText={props.errors.customAmount || ' '}
                      InputProps={{
                        classes: {
                          root: classes.inputRoot,
                          underline: classes.inputUnderline
                        }
                      }}
                      inputRef={customFixedRef}
                      FormHelperTextProps={{
                        classes: {
                          root: classes.formHelperError
                        }
                      }}
                    />
                  </Fragment>
                  <LoaderButton
                    type="button"
                    onClick={() => {
                      props.setFieldValue('anonFlag', 0)
                      setTimeout(() => {
                        props.handleSubmit()
                      }, 40)
                    }}
                    variant="contained"
                    classes={{ button: classes.confirmButton }}
                    working={props.isSubmitting && props.values.anonFlag === 0}
                    disabled={props.isSubmitting}
                  >
                    Confirm
                  </LoaderButton>
                  <LoaderButton
                    type="button"
                    onClick={() => {
                      props.setFieldValue('anonFlag', 1)
                      setTimeout(() => {
                        props.handleSubmit()
                      }, 40)
                    }}
                    variant="contained"
                    classes={{ button: `${classes.confirmButton} anonymous` }}
                    working={props.isSubmitting && props.values.anonFlag === 1}
                    disabled={props.isSubmitting}
                  >
                    Confirm Anonymously
                  </LoaderButton>
                </Form>
              )}
            </Formik>
          )}
          {!showCustom && (
            <Formik
              initialValues={{ quantity: 1 }}
              validationSchema={QuantitySchema}
              onSubmit={(...args) => checkLogin(handleSubmit, ...args)}
            >
              {props => (
                <Form className={classes.form}>
                  <IconButton
                    size="small"
                    className={classes.closeConfirmButton}
                    onClick={() => handleCloseConfirm(props.resetForm)}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography className={classes.confirmText}>
                    How many?
                  </Typography>
                  <QuantityInput max={maxQuantity} min={1} name="quantity" />
                  <LoaderButton
                    type="submit"
                    variant="contained"
                    classes={{ button: classes.confirmButton }}
                    working={props.isSubmitting}
                  >
                    Confirm
                  </LoaderButton>
                </Form>
              )}
            </Formik>
          )}
        </Box>
      </Fade>

      <Fade in={showConfirm === false && showThanks === false && showApprove}>
        <Box textAlign="center" className={classes.actionArea}>
          <HelpText className={classes.helpText}>Tap to {actionType}</HelpText>
          <Button onAction={handlePurchaseButtonClick}>
            {actionType} {item.open_item ? '' : `$${bidAmount}`}
          </Button>
          {/* buttons */}
        </Box>
        {/* fade inner Box */}
      </Fade>
      <div className={classes.donateWrapper}>
        {showThanks && (
          <Fragment>
            <lottie-player
              src={JSON.stringify(lottieJson)}
              background="transparent"
              speed="1"
              style={{
                width: 300,
                height: 300,
                position: 'absolute',
                top: '-200px',
                left: '50%',
                transform: 'translateX(-50%)'
              }}
              autoplay
              loop
            />
            {/* <lottie-player
                src={JSON.stringify(bigLottie)}
                background="transparent"
                speed="1"
                style={{
                  width: '100vw',
                  height: '100vh',
                  position: 'absolute',
                  top: '0',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  display: 'none'
                }}
                autoplay
                loop
              /> */}
          </Fragment>
        )}
      </div>
      <Gradient />
    </Box>
  )
}
export default withStyles(styles, { withTheme: true })(FixedButton)



// WEBPACK FOOTER //
// ./src/components/EngagementButtons/FixedButton/index.jsx